import { type HandoverSpec } from '@/designs-dev/handover/types';
import { chat } from '@/karehero-app/handover/dynamic-flow-slices';
import FactsSheet from '@/karehero-app/tell-us-once/intake/FactsSheet';

import {
  HEALTH_CARD_LABEL,
  HEALTH_DONE,
  HEALTH_HELD,
  HEALTH_DONE_BULLETS,
  HEALTH_MID,
  HEALTH_MID_ANSWER,
  HEALTH_MID_BULLETS,
  HEALTH_START,
  HEALTH_START_ANSWER,
  HEALTH_START_BULLETS,
} from './HealthSummary.content';

const started = { ...HEALTH_START, answer: HEALTH_START_ANSWER };
const startedBullets = { ...HEALTH_START_BULLETS, answer: HEALTH_START_ANSWER };

/**
 * The voice agent's Health stage (AA1 questions 16 to 23), opened with what we
 * already hold and filled in by talking. From the voice agent spec for
 * Attendance Allowance.
 */
export const healthSummarySpec: HandoverSpec = {
  id: 'voice-agent-health-summary',
  title: 'Voice agent: Health',
  description:
    'The Health stage opens with what we already have, and the conversation fills the gaps.',
  canvas: true,
  links: [
    {
      label: 'Voice agent spec',
      url: 'https://claude.ai/artifact/BwDpcJ29jmV2e6SWadxZtx',
    },
  ],
  flows: [
    {
      title: 'The Health stage',
      steps: [
        {
          id: 'start',
          title: 'What we already have',
          render: () => chat([HEALTH_START], 0),
        },
        {
          id: 'filling',
          title: 'Filling the gaps',
          render: () => chat([started, HEALTH_MID], 1),
        },
        {
          id: 'done',
          title: 'Done',
          render: () =>
            chat([started, { ...HEALTH_MID, answer: HEALTH_MID_ANSWER }, HEALTH_DONE], 2),
        },
      ],
    },
    {
      title: 'Variant: a card from us',
      steps: [
        {
          id: 'bullets-start',
          title: 'What we already have',
          render: () => chat([HEALTH_START_BULLETS], 0),
        },
        {
          id: 'bullets-edit',
          title: 'The pencil opens the rows',
          render: () => (
            <>
              {chat([HEALTH_START_BULLETS], 0)}
              <FactsSheet
                title={HEALTH_CARD_LABEL}
                groups={HEALTH_HELD}
                onClose={() => {}}
              />
            </>
          ),
        },
        {
          id: 'bullets-edit-row',
          title: 'A row opens in the same drawer',
          render: () => (
            <>
              {chat([HEALTH_START_BULLETS], 0)}
              <FactsSheet
                title={HEALTH_CARD_LABEL}
                groups={HEALTH_HELD}
                onClose={() => {}}
                initialEditing='gp'
              />
            </>
          ),
        },
        {
          id: 'bullets-filling',
          title: 'Filling the gaps',
          render: () => chat([startedBullets, HEALTH_MID_BULLETS], 1),
        },
        {
          id: 'bullets-done',
          title: 'Done',
          render: () =>
            chat(
              [
                startedBullets,
                { ...HEALTH_MID_BULLETS, answer: HEALTH_MID_ANSWER },
                HEALTH_DONE_BULLETS,
              ],
              2,
            ),
        },
      ],
    },
  ],
  states: [],
  components: {},
};
